export default "__VITE_ASSET__BzyAjkRM__"